import script from "./BuildingLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingLoader.vue?vue&type=script&setup=true&lang=js"

import "./BuildingLoader.vue?vue&type=style&index=0&id=5c749c65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c749c65"]])

export default __exports__